/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { IContentLoaderProps } from "react-content-loader";
import { Loader, LoaderProps } from "@nordcloud/gnui";

type LoaderWrapProps<T = Record<string, never>> = IContentLoaderProps &
  LoaderProps &
  T & {
    loading: boolean;
    children: React.ReactNode;
    Component?: React.FunctionComponent<LoaderProps>;
  };

export function LoaderWrap<T = Record<string, never>>({
  loading,
  children,
  Component = Loader,
  ...props
}: LoaderWrapProps<T>) {
  return loading ? <Component {...props} /> : <>{children}</>;
}
